export type AdminActionTone = 'ok' | 'err' | 'warn' | 'neutral';

const MODERATION_PREFIX = 'moderation.';

const LABELS: Readonly<Record<string, string>> = {
  'moderation.approve': 'Approved',
  'moderation.reject': 'Rejected',
  'moderation.merge': 'Merged',
  'moderation.edit_handoff_started': 'Started editing',
};

const TONES: Readonly<Record<string, AdminActionTone>> = {
  'moderation.approve': 'ok',
  'moderation.reject': 'err',
  'moderation.merge': 'warn',
};

export function actionLabel(action: string): string {
  const known = LABELS[action];
  if (known) return known;
  if (!action.startsWith(MODERATION_PREFIX)) return action;
  const rest = action.slice(MODERATION_PREFIX.length).replaceAll('_', ' ');
  if (rest.length === 0) return action;
  return rest.charAt(0).toUpperCase() + rest.slice(1);
}

export function actionTone(action: string): AdminActionTone {
  return TONES[action] ?? 'neutral';
}
